var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_10853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4882 62.2451C67.6802 62.2451 62.1602 67.7651 62.1602 74.5784C62.1602 81.3918 67.6802 86.9118 74.4935 86.9118C81.3068 86.9118 86.8268 81.3918 86.8268 74.5784C86.8268 67.7651 81.3042 62.2451 74.4882 62.2451ZM82.0455 76.5784H76.4882V82.1358C76.4882 83.2398 75.5922 84.1358 74.4882 84.1358C73.3788 84.1358 72.4882 83.2398 72.4882 82.1358V76.5784H66.9362C65.8322 76.5784 64.9362 75.6824 64.9362 74.5784C64.9362 73.4744 65.8322 72.5784 66.9362 72.5784H72.4882V67.0265C72.4882 65.9225 73.3842 65.0265 74.4882 65.0265C75.5922 65.0265 76.4882 65.9225 76.4882 67.0265V72.5784H82.0455C83.1548 72.5784 84.0508 73.4744 84.0508 74.5784C84.0508 75.6824 83.1548 76.5784 82.0455 76.5784Z",
    fill: "#26BAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9969 43.8747C60.7622 43.8747 65.4342 39.2027 65.4342 33.4373C65.4342 27.6747 60.7622 23 54.9969 23C49.2316 23 44.5596 27.6747 44.5596 33.4373C44.5596 39.2027 49.2316 43.8747 54.9969 43.8747ZM54.9969 25.6667C59.2796 25.6667 62.7676 29.152 62.7676 33.4373C62.7676 37.7227 59.2796 41.208 54.9969 41.208C50.7142 41.208 47.2262 37.7227 47.2262 33.4373C47.2262 29.152 50.7142 25.6667 54.9969 25.6667Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0798 84.3333H48.3225H45.6558H41.5038V64.92C41.5038 63.4693 41.6878 62.0747 42.0051 60.7413C42.2371 59.776 42.5438 58.8453 42.9251 57.9627C45.1358 52.808 49.7118 49.2507 54.9971 49.2507C61.2745 49.2507 66.5518 54.264 68.0531 61.0187C68.8585 60.6347 69.6985 60.3227 70.5731 60.088C68.7038 52.3093 62.4478 46.584 54.9971 46.584C48.7465 46.584 43.3385 50.6133 40.6478 56.504C40.2798 57.312 39.9651 58.1547 39.7038 59.0267C39.1491 60.8773 38.8345 62.856 38.8345 64.92V84.3333V87H48.3198H66.0425C64.9411 86.248 63.9465 85.3467 63.0798 84.3333Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6584 53.2163C40.1758 53.2163 43.8344 49.5549 43.8344 45.0403C43.8344 40.5256 40.1758 36.8643 35.6584 36.8643C31.1438 36.8643 27.4824 40.5256 27.4824 45.0403C27.4824 49.5549 31.1438 53.2163 35.6584 53.2163ZM35.6584 39.5283C38.6984 39.5283 41.1678 42.0003 41.1678 45.0376C41.1678 48.0749 38.6958 50.5469 35.6584 50.5469C32.6211 50.5469 30.1491 48.0749 30.1491 45.0376C30.1491 42.0003 32.6184 39.5283 35.6584 39.5283Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6664 84.3333V69.7013C25.6664 63.2506 30.1518 58.0026 35.6611 58.0026C37.1038 58.0026 38.4691 58.3786 39.7091 59.0266C39.9704 58.1546 40.2851 57.3093 40.6531 56.5039C39.1224 55.7573 37.4371 55.3359 35.6638 55.3359C28.6691 55.3359 23.0024 61.7653 23.0024 69.7013V86.9999H38.8398V84.3333H25.6664Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_10853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.a94906892e71b1e5b8a1d8e46919c393.svg";
export { ForwardRef as ReactComponent };